import Sites from "./Sites";
import './sites.scss';

export default Sites;